// src/utils/dndApi.js
// Client for the company DND (Do-Not-Disturb) endpoints. Mirrors src/utils/invoicingApi.js
// and src/utils/commandCenterApi.js for the apiInstance import + qs-building. The auth
// token is injected automatically by the apiAuth request interceptor.
import apiInstance from './apiAuth';

// Single source of truth for the DND reason categories (value = canonical backend CODE,
// label = human-readable text). Reused by AddToDndDialog and every DND consumer (T4/T5/T6).
export const DND_REASON_OPTIONS = [
  { value: 'BLACKLISTED', label: 'Blacklisted' },
  { value: 'ALREADY_PURSUED', label: 'Already being pursued' },
  { value: 'ASKED_NOT_TO_CONTACT', label: 'Asked not to contact' },
  { value: 'OTHER', label: 'Other' },
];

const qs = (params = {}) => {
  // Drop empty values so the URL stays clean and the backend applies its defaults.
  const clean = {};
  Object.keys(params).forEach((k) => {
    const v = params[k];
    if (v !== undefined && v !== null && v !== '') clean[k] = v;
  });
  const q = new URLSearchParams(clean).toString();
  return q ? `?${q}` : '';
};

// POST /company/<pk>/mark-dnd/  body { reason_category, note }
export const markDnd = (companyId, { reason_category, note } = {}) =>
  apiInstance.post(`company/${companyId}/mark-dnd/`, { reason_category, note });

// DELETE /company/<pk>/remove-dnd/
export const removeDnd = (companyId) =>
  apiInstance.delete(`company/${companyId}/remove-dnd/`);

// GET /company/<pk>/dnd-details/
export const getDndDetails = (companyId) =>
  apiInstance.get(`company/${companyId}/dnd-details/`);

// GET /company/dnd-list/?page=&search=
export const getDndList = ({ page, search } = {}) =>
  apiInstance.get(`company/dnd-list/${qs({ page, search })}`);

export const dndApi = { markDnd, removeDnd, getDndDetails, getDndList, DND_REASON_OPTIONS };

export default dndApi;
